import React from 'react'
import { css } from '@emotion/react'
import Markdown from 'markdown-to-jsx'
import { desktopMinWidth, desktopMaxWidth } from '../../tokens/mediaquery'

type Props = {
  text: string
}

export const Title: React.FC<Props> = (props) => {
  return (
    <h1
      css={css`
        margin: 8px 0 0;
        line-height: 1.5;
        letter-spacing: 0.01em;
        @media (max-width: ${desktopMaxWidth}) {
          font-size: 20px;
        }
        @media (min-width: ${desktopMinWidth}) {
          font-size: 28px;
        }
      `}
    >
      <Markdown options={{}}>{props.text}</Markdown>
    </h1>
  )
}
